import { analytics, db, functions } from "../firebase";
import { ENewsCategories, NewsStory, NEWS_TIMESTAMP_CREATED_AT_FIELD, NEWS_TIMESTAMP_UPDATED_AT_FIELD, NEWS_TIMESTAMP_PUBLISHED_AT_FIELD } from "../../types/db";
import { LISTING_IMAGE_4 } from "../../utilities/TestingUtils";
import { StorageNewsFEService } from "../storage";
import { HTTP_STORY_CONTENT_NEWS } from "../../types/functions";
import { NewsService } from "../../types/services/news/NewsService";
import { IMAGE_LOGO_NAME } from "../../types/constants";
import { FirestoreTimestampConst, FirestoreTimestampServerValue } from "../../types/db/common";

export class NewsFEService extends NewsService {
    constructor() {
        super(db);
    }

    async create(data: Omit<NewsStory, typeof NEWS_TIMESTAMP_CREATED_AT_FIELD | typeof NEWS_TIMESTAMP_UPDATED_AT_FIELD | 'author'>, id?: string): Promise<string> {
        const { content, ...restData } = data;//we extract the content (md)

        const docId = await super.create({
            // [NEWS_TIMESTAMP_PUBLISHED_AT_FIELD]: FirestoreTimestampServerValue,
            ...restData,//potential overwrite of default published at
            author: {
                id: 'cohostop',
                display_name: 'CoHostOp',
                avatar_url: IMAGE_LOGO_NAME,
            },
            [NEWS_TIMESTAMP_CREATED_AT_FIELD]: FirestoreTimestampServerValue,
            [NEWS_TIMESTAMP_UPDATED_AT_FIELD]: FirestoreTimestampServerValue,
            content: ''//we don't want the full md in the firestore (put it the storage) TODO could have a summary here
        }, id);

        //put the content in the storage
        await (StorageNewsFEService(docId)).uploadMdForNews(content);

        return docId;
    }

    async update(id: string, data: Partial<NewsStory>): Promise<void> {
        const { content, ...restData } = data;//we extract the content (md)
        await super.update(
            id,
            {
                ...restData,
                [NEWS_TIMESTAMP_UPDATED_AT_FIELD]: FirestoreTimestampServerValue,
            }
        )
        //update the content in the storage
        if (!!content)
            await (StorageNewsFEService(id)).uploadMdForNews(content);
    }

    //only for single update of the publish date, use updateStory for general update
    updateStoryPublishDate = async (storyId: string, publishDate: Date) => {
        await this.update(storyId, {
            [NEWS_TIMESTAMP_PUBLISHED_AT_FIELD]: FirestoreTimestampConst.fromDate(publishDate),
        });
    }
}

/** Get the markdown content of a story */
const getStoryContent = async (storyID: string, locale: string) => {
    return functions.httpsCallable(HTTP_STORY_CONTENT_NEWS)({
        storyID,
        // storyID: '4ammSwaYp5ZtZVRGfImv',//this is the only one with markdown file data
        locale,
    })
        .then((res) => {
            return res.data as string;
        });
}

/** Get the full story details */
export const getStoryInfo = async (storyId: string, locale?: string) => {
    const [story, content] = await Promise.all([
        new NewsFEService().get(storyId),
        getStoryContent(storyId, locale || 'en')
    ]);

    return {
        ...story,
        content
    } as NewsStory & { content: string };
}

//todo remove (this is temporary to fill up the db)
export const createStory = () => {
    return new NewsFEService().create(
        {
            title: 'Title of a story - awesome stays!!',
            subtitle: '',
            image: LISTING_IMAGE_4,
            category: ENewsCategories.STAYS,
            content: '',
            tags: [],
            published_at: FirestoreTimestampConst.fromDate(new Date(Date.now() + 24 * 60 * 60 * 1000))
        }
    )
}


/** Send analytics events */
export const logNewsEvent = (
    pageName: "Main" | "About" | "Media" | "ProductRelease" | "Contact" | "Stories" | "Story",
    storyId?: string) => {
    analytics.logEvent("page_view",
        { page_location: "News", page_title: pageName, page_path: storyId });
}